import { type Locale } from 'date-fns'
import { de, enUS, es, fr, it } from 'date-fns/locale'

import { type Lang } from '@Types/lang'

export const dateFnsLocale: Record<Lang, Locale> = {
  fr,
  de,
  en: enUS,
  it,
  es,
}
